var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { renderToString } from 'react-dom/server';
import { AtomicSearchBoxInstantResults } from '../stencil-generated/search';
/**
 * This component serves as a wrapper for the core AtomicSearchBoxInstantResults.
 *
 * @param props
 * @returns
 */
export const SearchBoxInstantResultsWrapper = (props) => {
    const { template } = props, otherProps = __rest(props, ["template"]);
    const instantResultsRef = useRef(null);
    useEffect(() => {
        var _a;
        (_a = instantResultsRef.current) === null || _a === void 0 ? void 0 : _a.setRenderFunction((result, root) => {
            createRoot(root).render(template(result));
            return renderToString(template(result));
        });
    }, [instantResultsRef]);
    return (React.createElement(AtomicSearchBoxInstantResults, Object.assign({ ref: instantResultsRef }, otherProps)));
};
//# sourceMappingURL=SearchBoxInstantResultsWrapper.js.map